"use client";

import dynamic from "next/dynamic";

export const RichTextEditorLazy = dynamic(() => import("./editor").then((mod) => mod.RichtTextEditor), {
	ssr: true,
});
